export class Exception_value
{
    constructor(data, master)
    {
        if ('value' in data)
            this.value = data.value;
        else
            this.value = null;

        if ('type' in data)
            this.type = data.type;
        else
            this.type = master.get_type();
    }

    get_type()
    {
        return this.type;
    }

    get_value()
    {
        return this.value;
    }
}
